import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceStatusEnum } from 'src/shared/models/enums/invoiceStatusEnum';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { InvoiceStatus } from '../models/invoiceStatus';

type InvoiceStatusesProps = {
  status: InvoiceStatus;
  chipSize: 'small' | 'medium' | undefined;
};

export const InvoiceStatuses = (props: InvoiceStatusesProps) => {
  const { status, chipSize } = props;
  const { t } = useTranslation(['invoice']);

  if (!status || !status.id) {
    return null;
  }

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status.id === InvoiceStatusEnum.Paid && (
        <Tooltip describeChild title={`${t('invoice:invoiceStatus.Paid')}`} arrow>
          <CustomChip label={t('invoice:invoiceStatus.Paid')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status.id === InvoiceStatusEnum.UnPaid && (
        <Tooltip describeChild title={`${t('invoice:invoiceStatus.UnPaid')}`} arrow>
          <CustomChip label={t('invoice:invoiceStatus.UnPaid')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {status.id === InvoiceStatusEnum.PartlyPaid && (
        <Tooltip describeChild title={`${t('invoice:invoiceStatus.PartlyPaid')}`} arrow>
          <CustomChip label={t('invoice:invoiceStatus.PartlyPaid')} color='info' size={chipSize} />
        </Tooltip>
      )}
      {status.id === InvoiceStatusEnum.Overdue && (
        <Tooltip describeChild title={`${t('invoice:invoiceStatus.Overdue')}`} arrow>
          <CustomChip label={t('invoice:invoiceStatus.Overdue')} color='error' size={chipSize} />
        </Tooltip>
      )}
      {status.id === InvoiceStatusEnum.Canceled && (
        <Tooltip describeChild title={`${t('invoice:invoiceStatus.Canceled')}`} arrow>
          <CustomChip label={t('invoice:invoiceStatus.Canceled')} color='grey' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
